// Shared Tailwind class strings used by every v2 field. Lifted from
// StockSupplierModal so the visual language stays identical wherever a v2
// form renders.

export const inputBaseClass =
  'w-full text-sm border rounded-xl px-3 py-2 bg-white transition-colors ' +
  'focus:outline-none focus:ring-1 focus:ring-primaryColor/40 ' +
  'disabled:bg-slate-50 disabled:text-slate-400 disabled:cursor-not-allowed';

export const inputErrorClass = 'border-red-400';
export const inputIdleClass = 'border-slate-200';

export function inputCls(hasError, extra = '') {
  return [inputBaseClass, hasError ? inputErrorClass : inputIdleClass, extra]
    .filter(Boolean)
    .join(' ');
}

export const labelClass =
  'block text-[10px] font-bold uppercase tracking-wider text-slate-500 mb-1';

export const errorTextClass = 'text-xs text-red-500 mt-0.5';

export const sectionTitleClass =
  'text-[10px] font-bold uppercase tracking-wider text-slate-400 mb-3';
